enum PortalName {
    PRIVATE_LAYOUT_HEADER = 'private-layout-header',
}

export default PortalName
